import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-contacts',
  templateUrl: './my-contacts.component.html',
  styleUrls: ['./my-contacts.component.scss']
})
export class MyContactsComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {



  }

}
